import { Record } from 'immutable';

const PaperBasedHomeworkResultRecord = Record({
  completedAssignments: 0,
  totalAssignments: 0,
});

class PaperBasedHomeworkResult extends PaperBasedHomeworkResultRecord {}

export default PaperBasedHomeworkResult;




// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/PaperBasedHomeworkResult/model.js